import { addDays, format, isBefore, isEqual, parse } from 'date-fns';
import { GetCurrentDate } from 'src/packages/lci/constants/LCIConstant';
import { fieldInvalidMsg, fieldErrorMsg, nameInvalidMsg, fieldInvalidStr, fieldErrorStr, nameInvalidStr } from 'src/utils/validationMessages';
import AsVerificationText from '../i18n/AsVerificationText';
export const validatedMinDate = (input, label) => {
    const minDate = new Date('01/01/1900');
    const inputDate = new Date(input);
    if (input && inputDate < minDate) {
        return fieldErrorMsg(label, 'must be after 01/01/1900.', 'debe ser posterior al 01/01/1900.');
    }
};
export const validateEmail = (email, label) => {
    const regex = RegExp(/^([0-9a-zA-Z]([-\.\w]*[0-9a-zA-Z])*@([-\_.]*[0-9a-zA-Z]*[0-9a-zA-Z])*.[a-zA-Z]{2,9})$/i);
    if (email && (!email.match(regex) || email.length >= 140)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateDateIsOnOrBeforeToday = (input, label, t, required) => {
    const today = new Date();
    const minDate = new Date('01/01/1900');
    const inputDate = new Date(input);
    if (input && inputDate > today) {
        return fieldErrorMsg(label, 'must be on or before today\'s date.', 'debe ser igual o anterior a la fecha de hoy.');
    }
    else if (input && inputDate < minDate) {
        return fieldErrorMsg(label, `must be between 01/01/1900 and ${GetCurrentDate()}.`, `debe estar entre 01/01/1900 y ${GetCurrentDate()}.`);
    }
};
export const validateAddress = (address, label) => {
    if (!address) {
        return undefined;
    }
    else if (!address.match(/^[0-9A-Za-z .,?#'-]{1,30}$/)) {
        return fieldInvalidMsg(label);
    }
    return undefined;
};
export const validateCity = (city, label) => {
    if (!city) {
        return undefined;
    }
    if (!city.match(/^[ a-zA-Z.'-]{1,30}$/)) {
        return fieldErrorMsg(label, 'cannot exceed 30 characters.', 'no puede exceder 30 caracteres.');
    }
    return undefined;
};
export const validateTextArea = (value, label) => {
    const regex = /^[-a-zA-Z0-9' .,:;_#!*+=?&$@%\s]{0,255}$/;
    if (value && !regex.test(value)) {
        return fieldErrorMsg(label, AsVerificationText.invalidCharactersMessage.english, AsVerificationText.invalidCharactersMessage.spanish);
    }
};
export const validatePostalCode = (postalCode, claimantData, label) => {
    //@ts-ignore  
    const selectedCountryID = claimantData.claimantData.empCtryCde;
    const canadaPostalCodeRegex = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;
    const usaPostalCodeRegex = /^\d{5}(?:[-]\d{4})?$/;
    if (!postalCode) {
        return undefined;
    }
    else if (selectedCountryID === 'USA') {
        if (!postalCode.match(usaPostalCodeRegex))
            return fieldInvalidMsg(label);
    }
    else if (selectedCountryID === 'CAN') {
        if (!canadaPostalCodeRegex.test(postalCode))
            return fieldInvalidMsg(label);
    }
};
export const validateName = (name, label, t) => {
    const regex = RegExp(/^([-\\.'a-zA-Z]|^[-\\.'a-zA-Z][-\\.' a-zA-Z]{0,33}[-\\.'a-zA-Z])$/gm);
    if (name && !regex.test(name)) {
        return nameInvalidMsg(label);
    }
    return undefined;
};
export const validateAccommodationDetail = (value, accommodationType, label) => {
    const regex = /^[-a-zA-Z0-9' .,:;_#!*+=?&$@%\s]{0,255}$/;
    if (!regex.test(value)) {
        return fieldErrorMsg(label, AsVerificationText.invalidCharactersMessage.english, AsVerificationText.invalidCharactersMessage.spanish);
    }
};
export const isDateInGivenRange = (days, receivedDate, label) => {
    const minDate = new Date('01/01/1900');
    const inputDate = new Date(receivedDate);
    if (!receivedDate) {
        return undefined;
    }
    else if (receivedDate && inputDate < minDate) {
        return fieldErrorMsg(label, 'must be after 01/01/1900.', 'debe ser posterior al 01/01/1900.');
    }
    else {
        const datePolicy = parse(format(addDays(new Date(), -days), 'P'), 'P', new Date());
        const formattedReceivedDate = parse(receivedDate, 'P', new Date());
        if (isBefore(formattedReceivedDate, datePolicy)) {
            return fieldErrorMsg(label, 'is outside your company\'s policy.', 'está fuera de la política de su empresa.');
        }
        return undefined;
    }
};
export const handleDateChange = (receivedDate, receivedRequestDate, errorFor, label) => {
    if (!receivedDate && errorFor === 'eventReceivedDate') {
        return undefined;
    }
    else {
        if (receivedDate && receivedRequestDate) {
            if (receivedDate > receivedRequestDate) {
                if (errorFor === 'anticipatedEndDate')
                    return fieldErrorMsg(label, 'must be after the Requested Start Date.', 'debe ser posterior a la Fecha de Inicio Solicitada.');
                else if (errorFor === 'eventReceivedDate')
                    return fieldErrorMsg(label, 'must be equal to or after Event Received Date.', 'debe ser igual o posterior a la Fecha de Recepción del Evento.');
                else if (errorFor === 'startDate')
                    return fieldErrorMsg(label, 'must be equal to or before the anticipated End Date.', 'debe ser igual o anterior a la Fecha de Finalización Anticipada.');
            }
        }
        return undefined;
    }
};
export const validateActualEndDate = (value, label, actualStartDate, required) => {
    const actualBeginDate = (actualStartDate != null ? actualStartDate : new Date("01/01/1900"));
    if (required && !value) {
        return undefined;
    }
    if ((isBefore(parse(value, 'P', new Date()), actualBeginDate))) {
        return fieldErrorMsg(label, 'must not be before the start date.', 'no debe ser anterior a la fecha de inicio.');
    }
    else if ((isEqual(new Date(value), actualBeginDate))) {
        return fieldErrorMsg(label, 'must not be equal to the start date.', 'no debe ser igual a la fecha de inicio.');
    }
    else {
        return undefined;
    }
};
export const validateAnticipatedEndDate = (value, label, requestedStartDate) => {
    const anticipatedBeginDate = (requestedStartDate != null ? requestedStartDate : new Date("01/01/1900"));
    if (value && (isBefore(parse(value, 'P', new Date()), anticipatedBeginDate))) {
        return fieldErrorMsg(label, 'must not be before the start date.', 'no debe ser anterior a la fecha de inicio.');
    }
    else if (value && (isEqual(new Date(value), anticipatedBeginDate))) {
        return fieldErrorMsg(label, 'must not be equal to the start date.', 'no debe ser igual a la fecha de inicio.');
    }
    else {
        return undefined;
    }
};
export const validateCost = (cost, label) => {
    const regex = RegExp('^\\d{1,14}(?:\\.\\d{1,2})?$');
    if (cost && !cost.match(regex)) {
        return fieldErrorMsg(label, 'must be a valid dollar amount between 0 and 999,999,999.', 'debe ser un monto válido en dólares entre 0 y 999,999,999.');
    }
    return undefined;
};
export const normalizeNewLines = (value) => {
    if (!value) {
        return value;
    }
    return value.replace(/[\r\n]/g, '').trimStart();
};
/** Plain-string variants of the validators above, for honest-ui inputs (which cannot render JSX errors). */
export const validateNameStr = (name, label, language) => {
    const regex = RegExp(/^([-\\.'a-zA-Z]|^[-\\.'a-zA-Z][-\\.' a-zA-Z]{0,33}[-\\.'a-zA-Z])$/gm);
    if (name && !regex.test(name)) {
        return nameInvalidStr(label, language);
    }
    return undefined;
};
export const validateEmailStr = (email, label, language) => {
    const regex = RegExp(/^([0-9a-zA-Z]([-\.\w]*[0-9a-zA-Z])*@([-\_.]*[0-9a-zA-Z]*[0-9a-zA-Z])*.[a-zA-Z]{2,9})$/i);
    if (email && (!email.match(regex) || email.length >= 140)) {
        return fieldInvalidStr(label, language);
    }
    return undefined;
};
export const validateDateIsOnOrBeforeTodayStr = (inputDate, label, language) => {
    if (!inputDate) {
        return undefined;
    }
    if (inputDate > new Date()) {
        return fieldErrorStr(label, 'must be on or before today\'s date.', 'debe ser igual o anterior a la fecha de hoy.', language);
    }
    if (inputDate < new Date('01/01/1900')) {
        return fieldErrorStr(label, `must be between 01/01/1900 and ${GetCurrentDate()}.`, `debe estar entre 01/01/1900 y ${GetCurrentDate()}.`, language);
    }
    return undefined;
};
export const validateAddressStr = (address, label, language) => {
    if (address && !address.match(/^[0-9A-Za-z .,?#'-]{1,30}$/)) {
        return fieldInvalidStr(label, language);
    }
    return undefined;
};
export const validateCityStr = (city, label, language) => {
    if (city && !city.match(/^[ a-zA-Z.'-]{1,30}$/)) {
        return fieldErrorStr(label, 'cannot exceed 30 characters.', 'no puede exceder 30 caracteres.', language);
    }
    return undefined;
};
export const validatePostalCodeStr = (postalCode, allValues, label, language) => {
    const selectedCountryID = allValues?.claimantData?.empCtryCde;
    const canadaPostalCodeRegex = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;
    const usaPostalCodeRegex = /^\d{5}(?:[-]\d{4})?$/;
    if (!postalCode) {
        return undefined;
    }
    if (selectedCountryID === 'USA' && !usaPostalCodeRegex.test(postalCode)) {
        return fieldInvalidStr(label, language);
    }
    if (selectedCountryID === 'CAN' && !canadaPostalCodeRegex.test(postalCode)) {
        return fieldInvalidStr(label, language);
    }
    return undefined;
};
/** Parses the MM/DD/YYYY string honest-ui's DateInput keeps in form state. */
export const parseDateString = (value) => {
    if (!value || value.length !== 10) {
        return undefined;
    }
    const parsed = parse(value, 'MM/dd/yyyy', new Date());
    return isNaN(parsed.getTime()) ? undefined : parsed;
};
export const validatedMinDateStr = (input, label, language) => {
    if (input && input < new Date('01/01/1900')) {
        return fieldErrorStr(label, 'must be after 01/01/1900.', 'debe ser posterior al 01/01/1900.', language);
    }
    return undefined;
};
export const validateAccommodationDetailStr = (value, label, language) => {
    const regex = /^[-a-zA-Z0-9' .,:;_#!*+=?&$@%\s]{0,255}$/;
    if (value && !regex.test(value)) {
        return fieldErrorStr(label, AsVerificationText.invalidCharactersMessage.english, AsVerificationText.invalidCharactersMessage.spanish, language);
    }
    return undefined;
};
export const isDateInGivenRangeStr = (days, receivedDate, label, language) => {
    if (!receivedDate) {
        return undefined;
    }
    if (receivedDate < new Date('01/01/1900')) {
        return fieldErrorStr(label, 'must be after 01/01/1900.', 'debe ser posterior al 01/01/1900.', language);
    }
    if (days !== undefined) {
        const datePolicy = parse(format(addDays(new Date(), -days), 'P'), 'P', new Date());
        if (isBefore(receivedDate, datePolicy)) {
            return fieldErrorStr(label, 'is outside your company\'s policy.', 'está fuera de la política de su empresa.', language);
        }
    }
    return undefined;
};
/**
 * Date-ordering checks on real Date objects. The legacy handleDateChange compared MM/DD/YYYY strings,
 * so its 'startDate' branch never fired; here 'startDate' errors when the start is after the anticipated end
 * (pass the anticipated end as receivedDate and the start as receivedRequestDate).
 */
export const handleDateChangeStr = (receivedDate, receivedRequestDate, errorFor, label, language) => {
    if (!receivedDate || !receivedRequestDate) {
        return undefined;
    }
    if (errorFor === 'eventReceivedDate' && receivedDate > receivedRequestDate) {
        return fieldErrorStr(label, 'must be equal to or after Event Received Date.', 'debe ser igual o posterior a la Fecha de Recepción del Evento.', language);
    }
    if (errorFor === 'anticipatedEndDate' && receivedDate > receivedRequestDate) {
        return fieldErrorStr(label, 'must be after the Requested Start Date.', 'debe ser posterior a la Fecha de Inicio Solicitada.', language);
    }
    if (errorFor === 'startDate' && receivedDate < receivedRequestDate) {
        return fieldErrorStr(label, 'must be equal to or before the anticipated End Date.', 'debe ser igual o anterior a la Fecha de Finalización Anticipada.', language);
    }
    return undefined;
};
export const validateActualEndDateStr = (value, label, language, actualStartDate) => {
    if (!value) {
        return undefined;
    }
    const actualBeginDate = actualStartDate ?? new Date('01/01/1900');
    if (isBefore(value, actualBeginDate)) {
        return fieldErrorStr(label, 'must not be before the start date.', 'no debe ser anterior a la fecha de inicio.', language);
    }
    if (isEqual(value, actualBeginDate)) {
        return fieldErrorStr(label, 'must not be equal to the start date.', 'no debe ser igual a la fecha de inicio.', language);
    }
    return undefined;
};
export const validateAnticipatedEndDateStr = (value, label, language, requestedStartDate) => {
    if (!value) {
        return undefined;
    }
    const anticipatedBeginDate = requestedStartDate ?? new Date('01/01/1900');
    if (isBefore(value, anticipatedBeginDate)) {
        return fieldErrorStr(label, 'must not be before the start date.', 'no debe ser anterior a la fecha de inicio.', language);
    }
    if (isEqual(value, anticipatedBeginDate)) {
        return fieldErrorStr(label, 'must not be equal to the start date.', 'no debe ser igual a la fecha de inicio.', language);
    }
    return undefined;
};
export const validateCostStr = (cost, label, language) => {
    const regex = RegExp('^\\d{1,14}(?:\\.\\d{1,2})?$');
    if (cost && !cost.match(regex)) {
        return fieldErrorStr(label, 'must be a valid dollar amount between 0 and 999,999,999.', 'debe ser un monto válido en dólares entre 0 y 999,999,999.', language);
    }
    return undefined;
};
